import { useState } from 'react';
import WeatherInfo from './WeatherInfo'
import WeatherForcast from './WeatherForcast.js'
import axios from 'axios';
import './Weather.css'
export default function Weather(props){
    const [ready, setReady] = useState(false);
    const [city, setCity] = useState(props.defaultCity)
    const [weatherData, setWeatherData] = useState({});

    function handleResponse(response){
        console.log(response.data.condition.icon_url)
        setWeatherData({
        city: response.data.city,
        coordinates: response.data.coordinates,
        temperature: response.data.temperature.current,
        description: response.data.condition.description,
        humidity: response.data.temperature.humidity,
        wind: response.data.wind.speed,
        date: new Date((response.data.time)*1000),
        icon: response.data.condition.icon
    })
      setReady(true);
    }
    
    if (ready === false) {
    search(city)
    return "Loading..."
   
    
   
}
 function search(city){
const apiKey= "02ccbb242b049d619a5146ftbb339do7";
    let apiUrl=`https://api.shecodes.io/weather/v1/current?query=${city}&key=${apiKey}&units=metric`;
    axios.get(apiUrl).then(handleResponse)
 }

 function handleSubmit(event){
    event.preventDefault();
    search(city);
    
 }
 
 function handelChangeCity(event) {
    setCity(event.target.value);
 }

  if (ready === true) {
return (
        <div className="weather">
        <form onSubmit={handleSubmit}>
         <div className="row">
           <div className="col-9">
             <input type="search" placeholder="Enter a city.."
             className="form-control"
            autoFocus="on"
            onChange={handelChangeCity}/>
           </div>
           <div className="col-3">
            <input type="submit" value="search" className="btn btn-primary w-100 " />
            </div>
         </div>
        </form>
        <WeatherInfo data={weatherData}/>
        <WeatherForcast coordinates={weatherData.coordinates} />
        
         </div>
    
    )
}
  }
    